import { IDS_CATEGORIES_REGIMES_ALIMENTAIRES } from "@/config/categorieRegimeIds";

export const MAP_CATEGORIE_PRODUITS_DETAILLES = [
  {
    code_parcel: "EL.BVV",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.VIANDE_ROUGE,
  },
  {
    code_parcel: "EL.LAI",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.PRODUITS_LAITIERS,
  },
  {
    code_parcel: "EL.OEU",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.OEUFS,
  },
  {
    code_parcel: "EL.OVV",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.VIANDE_BLANCHE,
  },
  {
    code_parcel: "EL.VLA",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.VIANDE_BLANCHE,
  },
  {
    code_parcel: "EL.VPO",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.VIANDE_BLANCHE,
  },
  {
    code_parcel: "FR.ABR",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.AMA",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.BAI",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.CER",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.CHA",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.FIG",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.FRA",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.FRB",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.KIW",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.MAN",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.NEC",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.NOS",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.NOX",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.OLI",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.PAM",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.PEC",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.POI",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.POM",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.PRU",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "FR.RAI",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.FRUITS,
  },
  {
    code_parcel: "GC.AVO",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.CEREALES,
  },
  {
    code_parcel: "GC.BET",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.SUCRE,
  },
  {
    code_parcel: "GC.BLD",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.CEREALES,
  },
  {
    code_parcel: "GC.BLT",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.CEREALES,
  },
  {
    code_parcel: "GC.CER",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.CEREALES,
  },
  {
    code_parcel: "GC.COL",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.HUILE,
  },
  {
    code_parcel: "GC.HAR",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMINEUSES,
  },
  {
    code_parcel: "GC.LEN",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMINEUSES,
  },
  {
    code_parcel: "GC.MAGR",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "GC.ORG",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.CEREALES,
  },
  {
    code_parcel: "GC.PDT",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.PATATE,
  },
  {
    code_parcel: "GC.POS",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMINEUSES,
  },
  {
    code_parcel: "GC.SEI",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.CEREALES,
  },
  {
    code_parcel: "GC.SOJ",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.CEREALES,
  },
  {
    code_parcel: "GC.TOU",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.HUILE,
  },
  {
    code_parcel: "LG.AIL",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.ART",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.ASP",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.AUB",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.BRE",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.CAR",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.CEL",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.CHO",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.CIT",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.CON",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.COU",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.EPI",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.HAR",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.MAI",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.MEL",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.POR",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.POS",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMINEUSES,
  },
  {
    code_parcel: "LG.POV",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.RAD",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.SAL",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
  {
    code_parcel: "LG.TOM",
    id_categorieRegime: IDS_CATEGORIES_REGIMES_ALIMENTAIRES.LEGUMES,
  },
];
